import { filter, orderBy } from 'lodash';
import React, { Component } from 'react';

import { NoData } from 'src/components/common/noData/NoData';

import { ErroredPathItem } from './erroredPathItem/ErroredPathItem';

interface Props {
  pathErrorStats: {
    path: undefined | null | string;
    requestsWithErrorsCount: number;
    errorsCount: number;
  }[];
  serviceId: string;
  expandFirstN?: number;
  timeFrom: string;
  timeTo: string;
  queryId?: string;
}

export class ErroredPathsList extends Component<Props> {
  shouldComponentUpdate(nextprops: Props) {
    const { pathErrorStats } = this.props;
    const newPathErrorStats = nextprops.pathErrorStats;
    if (pathErrorStats.length !== newPathErrorStats.length) return true;

    const errorCounts = pathErrorStats.map((stat) => stat.errorsCount);
    const newErrorCounts = newPathErrorStats.map((stat) => stat.errorsCount);

    const j = pathErrorStats.length;
    for (let i = 0; i < j; i++) {
      if (errorCounts[i] !== newErrorCounts[i]) return true;
    }

    return false;
  }

  render() {
    const {
      pathErrorStats,
      serviceId,
      timeFrom,
      timeTo,
      queryId,
      expandFirstN = 0,
    } = this.props;

    if (!pathErrorStats.length) {
      const item = queryId ? 'query' : 'service';
      const noDataProps = {
        message: 'No errors',
        secondary: `No errors were recorded for this ${item}.`,
      };
      return <NoData {...noDataProps} />;
    }

    const originalProps = {
      serviceId,
      timeFrom,
      timeTo,
      queryId,
    };

    const filteredPaths = filter(
      pathErrorStats,
      (p) => !!p.requestsWithErrorsCount,
    );
    const sortedPaths = orderBy(
      filteredPaths,
      (pathWithError) => -1 * pathWithError.requestsWithErrorsCount,
    );
    const sortedPathsList = sortedPaths.map((pathWithError, index) => {
      const path = pathWithError.path || index;
      return (
        <ErroredPathItem
          key={`path-error-${path}`}
          initiallyExpanded={index < expandFirstN}
          {...pathWithError}
          {...originalProps}
        />
      );
    });

    return sortedPathsList;
  }
}
